import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import ReferralsPage from './ReferralsPage';

export default flowRight(withVerificationGuard, withAuthGuard())(ReferralsPage);
